import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  TextField,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import NewPreviewUI from "./NewPreviewUI";
import PreviewBox from "./PreviewBox";
import { setpreviewLogout } from "../../redux/slices/Preview";
import BanquetOptions from "./BanquetOptions";

const BookModelRight = (layoutItem) => {
  const [eventName, setEventName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [customisationId, setCustomisationId] = useState(null);

  // Redux state
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const meetingObj = localStorage.getItem("meetingObject");
  const meetingObject = JSON.parse(meetingObj);
  const previewObject = useSelector((state) => state.preview.previewObject);
  const dispatch = useDispatch(); // For potential Redux state update

  const handleSubmit = async () => {
    if (!eventName.trim()) {
      setError("Event name is required");
      return;
    }

    const newHeaders = {
      Authorization: headers.headers.Authorization,
    };

    setLoading(true);
    setError("");
    let formData = new FormData();
    const requestBody = {
      path: "eventcustomisation",
      query: {
        eventName: eventName,
      },
      emmsId: `${curremms.curremms.id}`,
      requestType: "POST",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };

    formData.append("jsonData", JSON.stringify(requestBody));
    formData.append("file", null);

    try {
      const response = await axios.post(
        api + `/emms/piggyback/formdata`,
        formData,
        { headers: newHeaders }
      );

      setCustomisationId(response.data.customisationId);
    } catch (err) {
      console.error("API error:", err);
      setError("An error occurred while creating the event");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {}, [customisationId]);
  const handleBack = () => {
    const meetingObj = localStorage.getItem("meetingObject");
    const meetingObject = JSON.parse(meetingObj);
    if (meetingObject?.customProperties?.customisationId) {
      delete meetingObject.customProperties.customisationId;
      localStorage.setItem("meetingObject", JSON.stringify(meetingObject));
    }
    setCustomisationId(null);
    dispatch(setpreviewLogout());
  };

  const customProperties = previewObject || {};
  const { imageUrl, primaryColor, fontColor, fontStyle } = customProperties;

  return (
    <Box sx={{ maxWidth: 400, margin: "auto", textAlign: "center", mt: 1 }}>
      {meetingObject?.customProperties?.customisationId ? (
        <Box>
          <PreviewBox
            imageUrl={imageUrl}
            primaryColor={primaryColor}
            fontColor={fontColor}
            fontStyle={fontStyle}
          />
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={handleBack}
            sx={{ mt: 2 }}
          >
            Create New Customisation
          </Button>
        </Box>
      ) : (
        <>
          <Typography variant="h6">Use Content AI</Typography>
          <TextField
            label="Event keywords"
            variant="outlined"
            fullWidth
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
            error={!!error}
            helperText={error}
            sx={{ my: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            disabled={loading}
            sx={{ mb: 2 }}
          >
            {loading ? <CircularProgress size={24} /> : "Create"}
          </Button>

          {customisationId && (
            <Box mt={4}>
              <Typography variant="h6">Preview</Typography>
              <NewPreviewUI
                customisationId={customisationId}
                setCustomisationId={setCustomisationId}
                layoutItem={layoutItem}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default BookModelRight;
